<template>
    <div class="modal-container">
        <div class="modal-header">
            <h4 class="modal-title">{{ transactionId }}</h4>
            <md-button class="md-simple md-just-icon md-round modal-default-button" @click.stop="$modal.hide">
                <md-icon>clear</md-icon>
            </md-button>
        </div>
        <div class="modal-body">
            <md-table>
                <md-table-row>
                    <md-table-head>No Of Users</md-table-head>
                    <md-table-head>No Of Admins</md-table-head>
                    <md-table-head>No Of Stops</md-table-head>
                    <md-table-head>No Of Vehicles</md-table-head>
                    <md-table-head>No Of Gps Units</md-table-head>
                    <md-table-head>Term</md-table-head>
                    <md-table-head>Billing Plan</md-table-head>
                </md-table-row>
                <md-table-row v-for="(item, itemIndex) in items" :key="`details-${itemIndex}`">
                    <md-table-cell>
                        <template v-if="!item.noOfUsers && !item.userLicenseFee">
                            -
                        </template>
                        <template v-else>
                            {{ item.noOfUsers }}
                            x {{ currency }}
                            {{ formatNumber(item.userLicenseFee, 2) }}
                        </template>
                    </md-table-cell>
                    <md-table-cell>
                        <template v-if="!item.noOfAdmins && !item.adminLicenseFee">
                            -
                        </template>
                        <template v-else>
                            {{ item.noOfAdmins }}
                            x {{ currency }}
                            {{ formatNumber(item.adminLicenseFee, 2) }}
                        </template>
                    </md-table-cell>
                    <md-table-cell>
                        <template v-if="!item.noOfStops && !item.stopLicenseFee">
                            -
                        </template>
                        <template v-else>
                            {{ item.noOfStops }}
                            x {{ currency }}
                            {{ formatNumber(item.stopLicenseFee, 2) }}
                        </template>
                    </md-table-cell>
                    <md-table-cell>
                        <template v-if="!item.noOfVehicles && !item.vehicleUnitPrice">
                            -
                        </template>
                        <template v-else>
                            {{ item.noOfVehicles }}
                            x {{ currency }}
                            {{ formatNumber(item.vehicleUnitPrice, 2) }}
                        </template>
                    </md-table-cell>
                    <md-table-cell>
                        <template v-if="!item.NoOfGpsUnits && !item.servicePrice">
                            -
                        </template>
                        <template v-else>
                            {{ item.NoOfGpsUnits }}
                            x {{ currency }}
                            {{ formatNumber(item.servicePrice, 2) }}
                        </template>
                    </md-table-cell>
                    <md-table-cell>
                        {{ item.term }}
                    </md-table-cell>
                    <md-table-cell>
                        {{ item.billingPlan }}
                    </md-table-cell>
                </md-table-row>
            </md-table>
        </div>
    </div>
</template>
<script>
export default {
    name: 'EntAgreementItemsModal',
    props: {
        transactionId: { type: String, required: true },
        currency: { type: String, required: true },
        items: { type: Array, required: true }
    },
    methods: {
        formatNumber(num, digit) {
            return (Math.round(num * 100) / 100).toFixed(digit).toLocaleString();
        }
    }
};
</script>
<style lang="scss" scoped>
.modal-container {
    max-width: 70%;
}
</style>
